//import React, { Component } from "react";
import React, { FC, useState, useEffect } from "react";
import getWeb3 from "./getWeb3";
import ThronezContract from "./contracts/Thronez.json";

import { makeStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Popper from '@material-ui/core/Popper';

const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 350,
        margin: 10,
        display: 'flex',
        flexDirection: 'column'
    },
    media: {
        width: 350
    },
}));

const ThronezCard = (props) => {

    const classes = useStyles();

    const [ imageURL, setImageURL ] = useState(null);
    const { info } = props;
    const [tokenId, setTokenId] = useState('');
    const [name, setName] = useState('');
    const [rank, setRank] = useState('');
    const [boss, setBoss] = useState('');
    const [power, setPower] = useState('');
    const [referralNum, setReferralNum] = useState('');
    const [price, setPrice] = useState('');

    useEffect(() => {
        if (info) {
            //window.alert(info.contract);
            init(info);
        }
    }, [info]);

    const init = async (info) => {
        const web3 = info.web3;
        const contract = info.contract;
        const tagInfo = info.tagInfo;
        const uri = await contract.methods.tokenURI(tagInfo.id).call();
        const decodedStr = Buffer.from(uri.split(',')[1], "base64");
        const data = JSON.parse(decodedStr);
        const decodeSvg = Buffer.from(data.image.split(',')[1], "base64");
        //window.alert(decodeSvg);
        setImageURL(decodeSvg.toString());
        setTokenId(tagInfo.id);
        setName(tagInfo.tag.name);
        setRank(data.rank);
        setBoss(tagInfo.tag.boss);
        setPower(tagInfo.tag.power);
        setReferralNum(tagInfo.tag.referralNum);

        const wei = await contract.methods.name_price().call();
        const price = web3.utils.fromWei(wei, 'ether')
        setPrice(price);
    }

    const getNewToken = async () => {
        const contract = info.contract;
        const tokenId = info.tagInfo.id;

        // 
        if (10 > info.tagInfo.tag.referralNum) {
            await contract.methods.recruit(tokenId, 1).send({
                from: info.account,
                value: 0
            });
        }
        else {
            window.alert(`You can't mint anymore from this token`);
        }
    }

    return (
        <div className="thronez-card-content">
            <Card className={classes.card}>
                <CardActionArea>
                    <CardMedia className={classes.media} title='THRONEZ Image' dangerouslySetInnerHTML={{ __html: imageURL }}>
                    </CardMedia>
                    <CardContent>
                        <Typography gutterBottom variant='h7' component='h4'>Token ID : {tokenId}</Typography>
                        <Typography gutterBottom variant='h7' component='h4'>Name : {name}</Typography>
                        <Typography gutterBottom variant='h7' component='h4'>Rank : {rank}</Typography>
                        <Typography gutterBottom variant='h7' component='h4'>Power : {power}</Typography>
                        <Typography gutterBottom variant='h7' component='h4'>Boss's Token ID : {boss}</Typography>
                        <Typography gutterBottom variant='h7' component='h4'>Number of Minted : {referralNum}</Typography>
                    </CardContent>
                </CardActionArea>
                <form className={classes.root} noValidate autoComplete="off">
                    <TextField id="standard-basic" label="New Name"/>
                    <Button variant="outlined" color="secondary"  >Apply ({ price } Matic)</Button>
                </form>
                <Button variant="outlined" color="primary" onClick={getNewToken }>Get a New Token (Free)</Button>
            </Card>
        </div>
    );
    //}
}

export default ThronezCard;
